import { render } from "./contract_room_card.vue?vue&type=template&id=ecd8feba"
import script from "./contract_room_card.vue?vue&type=script&lang=js"
export * from "./contract_room_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__